import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'audiences'
const verb = HttpMethod.DELETE

export default class OspreyAudienceDelete extends BaseAction {
    constructor(dataKey, onError) {
        const id = 'f6ffe83b-d73d-494e-893c-d821dd52a626'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    deleteAudience(params) {
        const { audienceId } = params
        this.path = `/${resource}/${audienceId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-delete.js